var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { generateGuestCode } from '../features/guestCode/guestCodeApi';
// ---------------------------------------------------------------------------
// Thunk
// ---------------------------------------------------------------------------
export const fetchGuestCode = createAsyncThunk('guestCode/generate', (body, { rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    try {
        return yield generateGuestCode(body);
    }
    catch (e) {
        const status = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.status;
        if (status === 401 || status === 403) {
            return rejectWithValue('Нет прав на генерацию кода. Обратись к администратору.');
        }
        return rejectWithValue('Что-то пошло не так. Попробуй ещё раз.');
    }
}));
// ---------------------------------------------------------------------------
// Slice
// ---------------------------------------------------------------------------
const initialState = {
    status: 'idle',
    data: null,
    errorMessage: null,
};
export const guestCodeSlice = createSlice({
    name: 'guestCode',
    initialState,
    reducers: {
        resetGuestCode: (state) => {
            state.status = 'idle';
            state.data = null;
            state.errorMessage = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGuestCode.pending, (state) => {
            state.status = 'loading';
            state.data = null;
            state.errorMessage = null;
        })
            .addCase(fetchGuestCode.fulfilled, (state, action) => {
            state.status = 'success';
            state.data = action.payload;
            state.errorMessage = null;
        })
            .addCase(fetchGuestCode.rejected, (state, action) => {
            var _a;
            state.status = 'error';
            state.data = null;
            state.errorMessage = (_a = action.payload) !== null && _a !== void 0 ? _a : 'Что-то пошло не так. Попробуй ещё раз.';
        });
    },
});
// ---------------------------------------------------------------------------
// Actions & Selectors
// ---------------------------------------------------------------------------
export const { resetGuestCode } = guestCodeSlice.actions;
export const selectGuestCodeStatus = (state) => state.guestCode.status;
export const selectGuestCodeData = (state) => state.guestCode.data;
export const selectGuestCodeError = (state) => state.guestCode.errorMessage;
export default guestCodeSlice.reducer;
